import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Verify from "../components/Verify/Verify";
import GenerateOtp from "../components/GenerateOtp/GenerateOtp";
import Declaration from "../components/Declaration/Declaration";
import Thankyou from "../components/Thankyou/Thankyou";
import CustomerFeedback from "../components/CustomerFeedback/CustomerFeedback";
import Pdf from "../components/Pdf/Pdf";
import DirectDebit from "../components/DirectDebit/DirectDebit";
import Axis_Otp from "../components/Axis_Otp/Axis_Otp";
import DocumentUpload from "../components/UploadDocuments/upload";
import SellerDeclaration from '../components/SellerDeclaration/SellerDeclaration'
import PolicySearch from "../components/PolicySearch/PolicySearch";
import CustomerDeclaration from "../components/CustomerDeclaration/CustomerDeclaration";
import VideoVerification from "../components/VideoVerification/VideoVerification"
import VideoConsent from "../components/VideoVerification/VideoConsent/VideoConsent"
import BlockedJourney from "../components/CustomerFeedback/BlockedJourney/BlockedJourney";
import OtpPage from "../components/pages/OtpPage";
import SelfiePage from "../components/pages/SelfiePage";
import PolicySpecficQuestions from "../components/PolicySpecficQuestions/PolicySpecficQuestions";
import IVCPage from "../components/IVC/IVCPage";
import PolicyPack from "../components/PolicyPack/PolicyPack";
import LinkView from "../components/LinkView/LinkView";
import PersonalDetails from "../components/TelebindingJourney/PiiDetails/PersonalDetails";
import PaymentDetails from "../components/TelebindingJourney/PaymentDetails/PaymentDetails";
import TelebindingOTP from "../components/TelebindingJourney/TelebindingOTP/TelebindingOTP";
import { ROUTES } from "../utils/constants";
import WaitingScreen from "../components/TelebindingJourney/WaitingScreen";
import DeclarationNotScreen from "../components/TelebindingJourney/DeclarationNotScreen";
import TechnicalErrorScreen from "../components/TelebindingJourney/TechnicalErrorScreen";



export default class Routes extends Component {
  render() {
    let [param, txnId] = window.location.search.split("=");
    param = param.substr(1);
    let redirectRoute = `/vu?id=${txnId}`;
    if (param === "pdf") {
      redirectRoute = `/pdf?id=${txnId}`;
    }
    if (param === "upload") {
      // redirectRoute = `/?upload=${txnId ? txnId : 9801000121}`;
      redirectRoute = `/axisotp?posvRefNumber=${txnId}`;
    }
    if (param === "uccs") {
      redirectRoute = `/uccs`;
    }

    console.log('param: ', param)
    return (
      // <BrowserRouter>
      <Switch>
        <Route exact path="/" component={LinkView} />
        <Route path="/vu" component={Verify} />
        <Route path="/vv" component={PolicyPack} />
        <Route path="/video-verification" component={VideoVerification} />
        <Route path="/video-consent" component={VideoConsent} />
        <Route path="/pdf" render={() => <Pdf txnId={txnId} />} />
        <Route path="/customer_feedback" component={CustomerFeedback} />
        <Route path="/generate_otp" component={OtpPage} />
        <Route path="/selfie" component={SelfiePage} />
        <Route path="/axisotp" component={Axis_Otp} />
        <Route path="/direct-debit" component={DirectDebit} />
        <Route path="/uccs" component={PolicySearch} />
        <Route path="/declaration" component={Declaration} />
        <Route path="/uploaddocument" component={DocumentUpload} />
        <Route path='/seller-declaration' component={SellerDeclaration} />
        <Route path='/customer-declaration' component={CustomerDeclaration} />
        <Route path='/policy-confirmation' component={PolicySpecficQuestions} />
        <Route path='/blocked_journey' component={BlockedJourney} />
        <Route path="/thankyou" component={Thankyou} />
        <Route path="/ivc" component={IVCPage} />
        <Route path={ROUTES.OTP_VERIFICATION} component={TelebindingOTP} />
        <Route path={ROUTES.PERSONAL_DETAILS} component={PersonalDetails} />
        <Route path={ROUTES.PAYMENT} component={PaymentDetails} />
        <Route path={ROUTES.WAITING} component={WaitingScreen} />
        <Route path={ROUTES.TECHNICAL_ERROR} component={TechnicalErrorScreen} />
        <Route path={ROUTES.NOT_DECLARATION} component={DeclarationNotScreen} />
        <Redirect path="*" to={redirectRoute} />
      </Switch>
      // </BrowserRouter>
    );
  }
}
